module.exports = __webpack_public_path__ + "img/ready-to-ship.467b7ad.svg";